import controller from './orders.controller';
import templateBase from './templates/orders-base.view.html';
import templateT1 from './templates/orders-t1.view.html';
import templateAD from './templates/orders.view-adaptative.html';



let OrdersComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};


changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative) {
        return templateAD;
    } else {
        if(response.ORDERS.component == 'template_t1'){
            return templateT1
        }else{
            return templateBase;
        }
    }
}

export default OrdersComponent;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/orders/orders.component.js
 **/